import { useAuth } from '../../hooks';
import { useEffect } from 'react';

export default function Impersonate() {
  const { onUpdate, setImpersonationToken } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.slice(1));
    const token = params.get('token');

    if (token) {
      const originalAccessToken = localStorage.getItem('accessToken');
      const refreshToken = localStorage.getItem('refreshToken');
      // Without a session of its own, the stored access token is the previous
      // impersonation's: the new one replaces both, never becomes the "own" one.
      const ownSession =
        !!originalAccessToken &&
        originalAccessToken !== localStorage.getItem('impersonationToken');

      localStorage.clear();

      if (originalAccessToken)
        localStorage.setItem('accessToken', originalAccessToken);
      if (refreshToken) localStorage.setItem('refreshToken', refreshToken);

      if (!ownSession) {
        onUpdate({ accessToken: token });
      }
      setImpersonationToken(token);
    }
    // replace() keeps the token out of the browser history.
    window.location.replace('/');
  }, []);

  return null;
}
